export default "__VITE_ASSET__JkcC8Y0m__"